<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-5 px-7">
    <div class="header">
      <h1 class="title">
        {{ $t(template.awardsTitle) }}
        <span
          v-if="itemMaxLength && $i18n.locale == 'ko'"
          class="max-length-guide"
        >
          최대 {{ itemMaxLength }}개 입력 가능</span
        >
        <span
          v-if="itemMaxLength && $i18n.locale == 'en'"
          class="max-length-guide"
        >
          You can enter Max {{ itemMaxLength }}</span
        >
      </h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideAwards"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <v-row v-if="obj">
          <v-col cols="12" class="col-md-11">
            <v-row>
              <v-col cols="12" :class="collength">
                <i-text-field
                  v-model="obj.awardsName"
                  :label="itemLabel('awardsName')"
                  v-maxlength="'awards_name'"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('awardsName', true),
                    rules.maxlength('awardsName'),
                  ]"
                  :class="[zeroRoundedClass]"
                ></i-text-field>
              </v-col>
              <v-col
                cols="12"
                v-if="awards === 'A'"
                :class="[collength, colclass]"
              >
                <i-text-field
                  :label="itemLabel('awardsOrg')"
                  v-model="obj.awardsOrg"
                  v-maxlength="'awards_org'"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('awardsOrg', true),
                    rules.maxlength('awardsOrg'),
                  ]"
                  :class="[zeroRoundedClass]"
                ></i-text-field>
              </v-col>
              <v-col cols="12" :class="[collength, colclass]">
                <CommonDatePicker
                  :label="itemLabel('awardsDate')"
                  useMaxCurrentDate
                  :readonly="isReadonly"
                  :rules="[rules.required('awardsDate', true)]"
                  v-model="obj.awardsDate"
                  :type="dateFormat === 'YYYY.MM' ? 'month' : 'date'"
                />
              </v-col>
              <v-col cols="12" :class="[collength, colclass]">
                <i-text-field
                  :label="itemLabel('awardsDesc')"
                  v-model="obj.awardsDesc"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('awardsDesc', true),
                    rules.maxlength('awardsDesc'),
                  ]"
                  :class="[rightRoundedClass]"
                ></i-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="col-md-1 pl-md-3 mb-8 mb-md-0"
            :class="colclass"
          >
            <i-btn elevation="0" color="primary" block @click="add">저장</i-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm">
        <v-row
          v-for="(item, i) in awardses"
          :key="'awardsrow' + i"
          class="mt-4"
        >
          <v-col cols="12" :class="{ 'col-md-11': !isReadonly }">
            <v-row>
              <v-col cols="12" :class="collength">
                <i-text-field
                  v-model="item.awardsName"
                  :label="itemLabel('awardsName')"
                  outlined
                  dense
                  hide-details="auto"
                  v-maxlength="'awards_name'"
                  :rules="
                    isReadonly
                      ? []
                      : [
                          rules.required('awardsName'),
                          rules.maxlength('awardsName'),
                        ]
                  "
                  :class="[leftRoundedClass]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
              <v-col
                cols="12"
                :class="[collength, colclass]"
                v-if="awards === 'A'"
              >
                <i-text-field
                  v-model="item.awardsOrg"
                  :label="itemLabel('awardsOrg')"
                  outlined
                  dense
                  hide-details="auto"
                  v-maxlength="'awards_org'"
                  :rules="
                    isReadonly
                      ? []
                      : [
                          rules.required('awardsOrg'),
                          rules.maxlength('awardsOrg'),
                        ]
                  "
                  @blur="save(i)"
                  :class="[zeroRoundedClass]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
              <v-col cols="12" :class="[collength, colclass]">
                <CommonDatePicker
                  :readonly="isReadonly"
                  :label="itemLabel('awardsDate')"
                  useMaxCurrentDate
                  :rules="[rules.required('awardsDate')]"
                  v-model="item.awardsDate"
                  @change="save(i)"
                  :type="dateFormat === 'YYYY.MM' ? 'month' : 'date'"
                />
              </v-col>
              <v-col cols="12" :class="[collength, colclass]">
                <i-text-field
                  v-model="item.awardsDesc"
                  :label="itemLabel('awardsDesc')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="
                    isReadonly
                      ? []
                      : [
                          rules.required('awardsDesc'),
                          rules.maxlength('awardsDesc'),
                        ]
                  "
                  @blur="save(i)"
                  :class="[rightRoundedClass]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="col-md-1 pl-md-3 mb-6 mb-md-0"
            :class="colclass"
            v-if="!isReadonly"
          >
            <i-btn
              elevation="0"
              color="normal"
              block
              outlined
              @click="remove(i)"
              >삭제</i-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { DialogMixin } from '@/mixin/dialog.js';
import { mdiCalendarBlank } from '@mdi/js';
import CommonDatePicker from '@/components/common/CommonDatePicker.vue';
import { snack } from '@/plugins/dialog/api';
export default {
  components: { CommonDatePicker },
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    itemArray: {
      type: Function,
      default: () => {},
    },
    itemDirectInput: {
      type: Function,
      default: () => {},
    },

    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  computed: {
    canAdd() {
      return (
        !this.opts.awards?.oMaxLength ||
        this.opts.awards?.oMaxLength > this.awardses.length
      );
    },
    itemMaxLength() {
      return +this.opts?.awards?.oMaxLength || 0;
    },
    collength: function() {
      return {
        'col-md-4': this.awards === 'B',
        'col-md-3': this.awards === 'A',
      };
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
  },
  mixins: [DialogMixin],
  data: () => ({
    mdiCalendarBlank,
    obj: null,
    awards: '',
    dateFormat: '',
    awardses: [],
    itemSeq: 1,
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    itemLabel: function(key) {
      var label = this.template[key];
      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }
      return label;
    },
    setting: function() {
      let $this = this;
      if (this.template.typeAwards) this.awards = this.template.typeAwards;
      if (this.opts) {
        for (let key in this.opts) {
          let prop = this.opts[key];
          if (prop.id.cvColumn === 'awardsDate') {
            $this.dateFormat = prop.oFormat;
          }
        }
      }

      this.settingData();
      this.obj = this.defaultObj();
    },
    settingData: function() {
      if (this.info && this.info.awards && this.info.awards.length > 0) {
        this.itemSeq = this.info.awards[0].id.seq;
        this.awardses = [];
        let $this = this;
        this.info.awards.forEach(function(v) {
          var date = '';
          if (v.awardsDate && $this.dateFormat === 'YYYY.MM.DD') {
            date =
              v.awardsDate.substring(0, 4) +
              '-' +
              v.awardsDate.substring(4, 6) +
              '-' +
              v.awardsDate.substring(6, 8);
          } else if (v.awardsDate && $this.dateFormat === 'YYYY.MM') {
            date =
              v.awardsDate.substring(0, 4) + '-' + v.awardsDate.substring(4, 6);
          }

          $this.awardses.push({
            awardsName: v.awardsName,
            seq: v.id.seq,
            awardsOrg: v.awardsOrg,
            awardsDesc: v.awardsDesc,
            awardsDate: date,

            datePicker: false,
          });

          $this.itemSeq =
            $this.itemSeq < v.id.seq ? v.id.seq + 1 : $this.itemSeq + 1;
        });
      }
    },
    defaultObj: function() {
      return {
        awardsName: '',
        seq: this.itemSeq++,
        awardsOrg: '',
        awardsDate: '',
        awardsDesc: '',
        datePicker: false,
      };
    },
    add: function() {
      if (!this.canAdd)
        return this.$showAlert(
          `${this.template.awardsTitle} 은(는) 최대 ${this.opts.awards.oMaxLength}개 까지 입력 가능 합니다.`,
        );
      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    remove: function(i) {
      this.delete(i);
    },

    valid: function() {
      //필수 여부 체크
      if (
        this.opts &&
        this.opts.awards &&
        this.opts.awards.oRequireYn &&
        this.opts.awards.oRequireYn == 'Y' &&
        this.awardses.length < 1
      ) {
        this.submitErrorMessage = this.$t(
          '최소 1개의 정보는 존재하여야 합니다.',
        );
        this.submitErrorAlert = true;
        return false;
      }

      return this.$refs.updateForm.validate();
    },
    save(i) {
      var tmp = i === -1 ? this.obj : this.awardses[i];
      var validYn = false;

      if (i === -1) validYn = this.$refs.saveForm.validate();
      else if (i !== -1) validYn = this.$refs.updateForm.validate();

      if (validYn) {
        const id = {
          annoId: this.$route.params.annoId,
          seq: tmp.seq,
        };

        var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거
        const p = {
          id: id,
          awardsName: tmp.awardsName,
          awardsDate: tmp.awardsDate.replace(pattern, ''),
          awardsOrg: tmp.awardsOrg,
          awardsDesc: tmp.awardsDesc,
        };

        this.$emit('save', p, 'awards', i);
      }
    },
    savecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('AWARDSES SAVE FAIL');
      } else {
        snack.info(
          `${this.$t(this.template.awardsTitle)}정보가 저장 되었습니다.`,
        );
        if (i === -1) {
          this.awardses.push(this.obj);
          this.obj = this.defaultObj();
          this.$refs.saveForm.resetValidation();
        }
      }
    },
    delete: function(i) {
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.awardses[i].seq,
      };
      this.$emit('delete', p, 'awards', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('AWARDSES DELETE FAIL');
      } else {
        snack.danger(
          `${this.$t(this.template.awardsTitle)}이 삭제 되었습니다.`,
        );
        this.awardses.splice(i, 1);
      }
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}
</style>
